import { get } from 'lodash/fp'
import { AppContext } from './AppContext'
import { UserMetadata } from './MultiFrontendContext'

/** @deprecated */
export const getUserOrgName = (appContext: AppContext) => {
  return get(['user_metadata', 'org_name'], appContext)
}

/** @deprecated */
export const getUserPicture = (appContext: AppContext) => {
  return get(['user_metadata', 'picture'], appContext)
}

/** @deprecated */
export const getUserName = (appContext: AppContext) => {
  return get(['user_metadata', 'name'], appContext)
}

/** @deprecated */
export const getUserEmail = (appContext: AppContext) => {
  return get(['user_metadata', 'email'], appContext)
}

/** @deprecated */
export const getUserIsAdmin = (appContext: AppContext) => {
  return get(['user_metadata', 'is_admin'], appContext)
}

/**
 * Get the operator identifier for workflow approvals.
 * For modern UserMetadata, returns the name (always present).
 * For legacy AppContext, prefers name, falls back to email, returns null if neither is available.
 * Safe to call during render - never throws.
 */
export function getOperatorName(userMetadata: UserMetadata): string
export function getOperatorName(
  appContext: AppContext | null | undefined,
): string | null
export function getOperatorName(
  contextOrMetadata: AppContext | UserMetadata | null | undefined,
): string | null {
  if (!contextOrMetadata) return null

  // Modern UserMetadata - name is always present
  if ('roles' in contextOrMetadata) {
    const userMetadata = contextOrMetadata as UserMetadata
    return userMetadata.name
  }

  // Legacy AppContext - fallback to email for backwards compatibility
  const appContext = contextOrMetadata as AppContext
  const name = get(['user_metadata', 'name'], appContext)
  const email = get(['user_metadata', 'email'], appContext)

  if (name) return name
  if (email) return email

  return null
}
